module.exports = __webpack_public_path__ + "static/media/favicon.1f8bbad7.png";